export default {
      id: "play-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#play",
      toString: function () {
        return this.url;
      }
    }